import React, { useState, useEffect, useContext } from 'react';
import { Navbar, Form, Nav, NavDropdown } from 'react-bootstrap';
import { Auth } from 'aws-amplify';
import { themeStore } from '../../contexts';
import { AiOutlineCloudSync } from 'react-icons/ai';
import { CgInfinity } from 'react-icons/cg';
import { useHistory } from 'react-router-dom';
import './styles.scss';

const CustomNavbar = (props) => {
	const history = useHistory();
	const { user, onSignOut, institution, currentClinic, clinics, setCurrentClinic } = props;
	const { setThemeState, themeState } = useContext(themeStore);
	const [username, setUsername] = useState('anonymous');
	const [group, setGroup] = useState('anonymous');
	const [clinic, setClinic] = useState('anonymous');

	useEffect(
		() => {
			console.log("CUSTOM BAR", user)
			if (user) {
				setUsername(user.email);
			}
			if (institution && institution.hasOwnProperty('label')) {
				setGroup(institution.label);
			} else {
				setGroup(user.groups);
			}
		},
		[user]
	);

	useEffect(() => {
		console.log("NAV::CurrentClinic ->", currentClinic);
		console.log("NAV::Clinics ->", clinics);
		if (currentClinic) {
			setClinic(currentClinic.clinic.label);
		} else if (currentClinic === undefined && clinics && clinics.length === 1) {
			setClinic(clinics[0].clinic.label);
		}
	}, [currentClinic, clinics])

	const signOut = async () => {
		await onSignOut()
	};
	const renderThemeSwitch = () => {
		return (
			<div className="align-items-center d-flex">
				<i className={!themeState ? 'fas fa-sun fa-2x text-primary' : 'fas fa-sun mr-2'} />
				<button
					style={{ background: 'none', border: 'none', outline: 'none' }}
					onClick={() => setThemeState(!themeState)}
				>
					<Form.Check type="switch" label="" checked={themeState} />
				</button>
				<i className={themeState ? 'fas fa-moon fa-2x text-primary' : 'fas fa-moon'} />
				{/* <button className={themeState ? 'btn btn-light' : 'btn btn-dark'} onClick={() => setThemeState(!themeState)}>{themeState ? 'Light Mode' : 'Dark Mode'}</button> */}
			</div>
		);
	};

	const switchClinics = () => {
		setCurrentClinic(null);
		history.push('/')
	}

	return (
		<Navbar expand="lg" className="shadow-sm" fixed="top">
			<div>
				{/* <Navbar.Brand href="/">CranialCloud Store</Navbar.Brand>
				<AiOutlineCloudSync /> */}
				<Navbar.Brand href="/">UPSTREAM</Navbar.Brand>
				<CgInfinity className="infinity-icon" />
			</div>
			<Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />
			<Navbar.Collapse id="basic-navbar-nav">
				<Nav className="mr-auto align-items-center">
					{/* <Nav.Link href="/surveys">Surveys</Nav.Link>
                    <Nav.Link href="/questions">Questions</Nav.Link> */}
				</Nav>
				<NavDropdown title={'Signed in as ' + username + ' (' + group + ')'}>
					{clinic !== 'anonymous' && (
					<>
						<Nav.Link className="dropdown-nav-item text-center">
							Clinic: {clinic}
						</Nav.Link>
						{clinics.length > 1 && (
							<Nav.Link onClick={switchClinics} className="dropdown-nav-item text-center">
								Switch clinic
							</Nav.Link>
						)}
					</>
					)}
					<button onClick={signOut} className="btn btn-light btn-block dropdown-nav-item">
						Sign Out
					</button>
					{/* <NavDropdown.Divider /> */}
					{/* <div className="d-flex justify-content-center">{renderThemeSwitch()}</div> */}
				</NavDropdown>
				<Nav.Link href="">
					<i className="fas fa-user-circle fa-2x" />
				</Nav.Link>
			</Navbar.Collapse>
		</Navbar>
	);
};

export default CustomNavbar;
